import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { RegisterForm } from '../../../components/auth/register-form/register-form';

@Component({
  selector: 'app-register',
  imports: [
    AuthPageLayoutComponent,
    RegisterForm,
  ],
  templateUrl: './register.html'
})
export class Register {

}
